// Textos gravados em "interaccion_del_usuario" pelos formulários de médico e instituição.
export const INTERACAO_INFORMADO_PELO_USUARIO = 'Item informado pelo usuário';
export const INTERACAO_NAO_ENCONTRADO = 'marcado checkbox não encontrado.';

// O modal de pesquisa de médico grava a interação já traduzida (translate.instant), então o texto salvo pode
// estar em português, espanhol ou inglês ("Ítem informado por el usuario", "Item entered by user",
// "Marcado checkbox no encontrado", "Marked checkbox not found"...). A detecção é por palavra-chave, sem acento.
export function interacaoManual(interacao: string | null | undefined): boolean {
  if (!interacao) return false;
  const texto = interacao.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  return /informado|encontrado|entered by user|not found/.test(texto);
}

// Nome da instituição que vai no Conteudo (e no CSV), mesma regra de médico e produto: reflete o nome validado
// (retorno_nome), e o que a IA leu fica em nome_instituicao_original. Sobrescreve quando o revisor escolheu um
// nome (ambiguidade, pesquisa ou digitação) ou, sem interação, quando o Maestro validou a instituição. Sem
// validação o retorno_nome é só o 1º candidato, e "não encontrada" não escolhe nome: ficam com o nome atual.
export function nomeInstituicaoFinal(
  atual: string | null | undefined,
  retornoNome: string | null | undefined,
  interacao: string | null | undefined,
  validInst: boolean | string | null | undefined
): string | null | undefined {
  if (!retornoNome) return atual;
  if (interacao) return interacao === INTERACAO_NAO_ENCONTRADO ? atual : retornoNome;
  return validInst === true || String(validInst).toLowerCase() === 'true' ? retornoNome : atual;
}

// Número do cadastro Maestro (nro_medico / nro_instit) que vai para o CSV. Nome digitado pelo revisor ou
// "não encontrado" não corresponde a um cadastro, então fica vazio — senão o retorno_* default (1º candidato
// da ambiguidade) ficaria ligado a um nome que o revisor escreveu. Nos demais casos (válido, ambiguidade,
// pesquisa) vale o retorno e, na falta dele, o que já estava gravado.
export function nroDoCadastro(interacao: string | null | undefined, retorno: string | null | undefined, atual: string | null | undefined): string {
  if (interacao === INTERACAO_INFORMADO_PELO_USUARIO || interacao === INTERACAO_NAO_ENCONTRADO || interacaoManual(interacao)) {
    return '';
  }
  return retorno || atual || '';
}
